import { create } from "zustand"
import { persist } from "zustand/middleware"

import type { AgentSetupId } from "./agent-setup"

interface AgentSetupDismissalsState {
	// Declined setup steps per workspace.
	byWorkspace: Record<string, AgentSetupId[]>
	dismiss: (workspaceId: string, id: AgentSetupId) => void
	restore: (workspaceId: string, id: AgentSetupId) => void
}

// Setup steps have no row to close, so a decline is kept in this browser.
export const useAgentSetupDismissals = create<AgentSetupDismissalsState>()(
	persist(
		(set) => ({
			byWorkspace: {},
			dismiss: (workspaceId, id) =>
				set((state) => ({
					byWorkspace: {
						...state.byWorkspace,
						[workspaceId]: [
							...new Set([...(state.byWorkspace[workspaceId] ?? []), id]),
						],
					},
				})),
			restore: (workspaceId, id) =>
				set((state) => ({
					byWorkspace: {
						...state.byWorkspace,
						[workspaceId]: (state.byWorkspace[workspaceId] ?? []).filter(
							(dismissed) => dismissed !== id,
						),
					},
				})),
		}),
		{ name: "agent-setup-dismissals" },
	),
)
